const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key];
  if (value === undefined) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
};

const parseBoolean = (value: string): boolean => {
  return value === 'true' || value === '1';
};

const parseNumber = (value: string, defaultValue: number): number => {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};

// Environment configuration
export const env = {
  // API Configuration
  // Pusty string = użyj Vite proxy (relatywny URL)
  API_URL: getEnvVar('VITE_API_URL', 'http://localhost:8001/api'),
  API_TIMEOUT: parseNumber(getEnvVar('VITE_API_TIMEOUT', '30000'), 30000),

  // Application Configuration
  APP_NAME: getEnvVar('VITE_APP_NAME', 'Novelist Admin'),
  APP_VERSION: getEnvVar('VITE_APP_VERSION', 'dev'),
  DEFAULT_LOCALE: getEnvVar('VITE_DEFAULT_LOCALE', 'pl'),
  AVAILABLE_LOCALES: getEnvVar('VITE_AVAILABLE_LOCALES', 'pl,en').split(','),

  // Feature Flags
  ENABLE_FILE_UPLOAD: parseBoolean(
    getEnvVar('VITE_ENABLE_FILE_UPLOAD', 'false')
  ),
  ENABLE_DEBUG: parseBoolean(getEnvVar('VITE_ENABLE_DEBUG', 'true')),

  // External integrations
  // Per-environment RevenueCat project, supplied by CI at build time.
  // Empty in local/dev builds: RevenueCat deep links are hidden then.
  RC_PROJECT_ID: getEnvVar('VITE_RC_PROJECT_ID', ''),
  SENTRY_DSN: getEnvVar('VITE_SENTRY_DSN', ''),
} as const;

// API Configuration export
export const API_CONFIG = {
  baseURL: env.API_URL,
  timeout: env.API_TIMEOUT,
} as const;

// Log configuration in development
if (env.ENABLE_DEBUG) {
  console.log('Environment configuration:', env);
}
